import { useState, useEffect } from 'react'
import { useIntl, defineMessages } from 'react-intl'
import { isEmpty } from 'lodash'

import { Autocomplete } from 'components/v2/Autocomplete'
import { useCompanyLinesAutocompleteQuery } from 'features/Lines/hooks'

const messages = defineMessages({
  error: {
    id: 'companyLines.autocomplete.error',
    defaultMessage: 'There was an issue while loading your company lines'
  },
  empty: {
    id: 'companyLines.autocomplete.empty',
    defaultMessage: 'No company lines found'
  }
})

export const CompanyLineAutocomplete = (props: TSFixMe): TSFixMe => {
  const intl = useIntl()
  const [pattern, setPattern] = useState('')
  const { companyLines, loading, error, refetch } = useCompanyLinesAutocompleteQuery({ companyId: props.companyId })

  useEffect((): TSFixMe => {
    refetch()
  }, [])

  const shownItems = companyLines.filter((companyLine): TSFixMe => {
    return companyLine.name.toLowerCase().indexOf(pattern.toLowerCase()) > -1
  })

  const handleChange = (companyLine: TSFixMe, { inputValue = '' } = {}): TSFixMe => {
    setPattern(inputValue)

    if (!isEmpty(companyLine)) {
      props.onChange(companyLine)
    } else {
      props.onChange({
        id: '',
        name: ''
      })
    }
  }

  return (
    <Autocomplete
      {...props}
      items={shownItems}
      getItemLabel={(companyLine: TSFixMe): TSFixMe => companyLine.name}
      loading={loading}
      error={error}
      errorMessage={intl.formatMessage(messages.error)}
      emptyMessage={intl.formatMessage(messages.empty)}
      onChange={handleChange}
    />
  )
}
